module.exports = __webpack_public_path__ + "media/הפתעה.2e0fe869.mp3";